module.exports = __webpack_public_path__ + "static/img/decoy.58ce8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/decoy.png
// module id = uUni
// module chunks = 0